// extracted by css-extract-rspack-plugin
export default {"header":"header-yUMGMB","searchContainer":"searchContainer-cjRBWv"};